import { forwardRef, type Ref, type SVGProps } from 'react';
import { SvgIcon } from '../../components/icon/icon';

interface SVGRProps {
  title?: string;
  titleId?: string;
}
const StarOutline = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    ref={ref}
    aria-labelledby={titleId}
    {...props}>
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      d="M17.131 21a.7.7 0 0 1-.324-.084L12 18.269l-4.807 2.647a.67.67 0 0 1-.734-.056.75.75 0 0 1-.278-.714l.918-5.606-3.888-3.97a.76.76 0 0 1-.177-.748.71.71 0 0 1 .563-.497l5.374-.818 2.403-5.1A.7.7 0 0 1 12 3c.265 0 .508.158.626.407l2.403 5.1 5.374.818c.263.04.48.232.563.497a.76.76 0 0 1-.177.749l-3.888 3.97.918 5.605a.75.75 0 0 1-.278.714.67.67 0 0 1-.41.14"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
const ForwardRef = forwardRef(StarOutline) as SvgIcon;
export { ForwardRef as ReactComponent };
